module.exports = __webpack_public_path__ + "static/img/5642.326e2008.png";